import { createModel } from "@rematch/core";
import { CustomerGroupFilterState, CustomerGroupResultState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: CustomerGroupResultState = {
  data: [],
  loading: false,
  meta: {
    ageMediumCount: 0,
    ageOldCount: 0,
    ageOldestCount: 0,
    ageYoungCount: 0,
    ageYoungestCount: 0,
    amountAllChurn: [{ churn: 0 }],
    amountAllClv: [{ clv: 0 }],
    amountSelChurn: [{ churn: 0 }],
    amountSelClv: [{ clv: 0 }],
    avgChurn: 0,
    avgChurnTotal: 0,
    avgClv: 0,
    avgClvTotal: 0,
    basicSupplyCount: 0,
    commonContact: "",
    contractCount: 0,
    count: 0,
    customerCount: 0,
    electricityCount: 0,
    gasCount: 0,
    heatingCount: 0,
    glassFiberCount: 0,
    nextBestActivityTopTen: [],
    optInCount: 0,
    page: 0,
    population: null,
    privateCustomerCount: 0,
    rowsPerPage: 0,
    selectedCount: 0,
    totalCount: 0,
  },
  pending: null,
};

interface Payload {
  customerGroupFilter: CustomerGroupFilterState;
  filter?: { [field: string]: string };
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  rowsPerPage?: number;
}

export const customerGroupResult = createModel<RootModel>()({
  state: initialState as CustomerGroupResultState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(
      state,
      payload: Partial<CustomerGroupResultState>,
      requestId: string
    ) {
      return multiRequest.updateSuccess(payload, state, requestId);
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchCustomerGroup(payload: Payload, rootState) {
      const requestId = multiRequest.getRequestId();
      dispatch.customerGroupResult.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.customerGroupResult.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const {
          customerGroupFilter,
          filter,
          page,
          rowsPerPage,
          sortBy,
          sortDirection,
        } = payload;

        const customerGroupResult = await api.fetchCustomerGroup(
          token,
          customerGroupFilter,
          page,
          rowsPerPage,
          filter,
          sortBy,
          sortDirection
        );

        dispatch.customerGroupResult.fetchSuccess(
          customerGroupResult,
          requestId
        );
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.customerGroupResult.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/customerGroupResult.ts